import { Link, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";

import Context from "../../context";

// ----------------------------------------------------------------------

type Props = {
	title: string;
	description: string;
	icon: string;
	seeMore?: string;
};

export const InfoItem = ({ title, description, icon, seeMore }: Props) => {
	const { state, values } = useContext(Context);
	const { translate } = useLocales();

	const isMobile = state.isMobile;

	return (
		<Stack flexDirection={"row"} alignContent={"start"}>
			<Iconify icon={icon} color={values.primaryTextColor} sx={{ mt: 0.3 }} />
			<Stack sx={{ ml: 2 }} gap={0.3}>
				<Typography
					variant='subtitle2'
					fontSize={isMobile ? 12 : 15}
					color={values.primaryTextColor}
				>
					{title}
				</Typography>
				<Typography
					variant='body1'
					fontSize={isMobile ? 11 : 13}
					color={values.secondaryTextColor}
					maxWidth={400}
				>
					{description}
					{seeMore && (
						<Link
							target='_blank'
							href={seeMore}
							variant='subtitle2'
							fontSize={isMobile ? 11 : 13}
							color={values.primaryColor}
						>
							{translate("info_panel.know_more")}
						</Link>
					)}
				</Typography>
			</Stack>
		</Stack>
	);
};

export default InfoItem;
